import {useEffect, useState} from 'react';

const BASE = process.env.REACT_APP_AWP_API_URL || 'https://awp.minsky.ai';

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token ? {'Authorization': `Bearer ${token}`} : {};
}

/**
 * Fetch aliases and corpus surface forms for a KB entity.
 *
 * @param {string} entityId  Wikidata Q-number or numeric entity_id.
 * @returns {{
 *   wikidataAliases: string[],
 *   surfaceForms: Array<{text: string, count: number, sourceTypes: string[]}>,
 *   loading: boolean,
 *   error: Error|null
 * }}
 */
export function useEntityAliases(entityId, refetchKey = 0) {
    const [wikidataAliases, setWikidataAliases] = useState([]);
    const [surfaceForms, setSurfaceForms] = useState([]);
    const [loading, setLoading] = useState(!!entityId);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!entityId) {
            setWikidataAliases([]);
            setSurfaceForms([]);
            setLoading(false);
            return;
        }

        let cancelled = false;
        setLoading(true);
        setError(null);

        fetch(`${BASE}/api/entities/${encodeURIComponent(entityId)}/aliases`, {
            headers: authHeaders(),
        })
            .then(r => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
            .then(data => {
                if (!cancelled) {
                    setWikidataAliases(Array.isArray(data.wikidataAliases) ? data.wikidataAliases : []);
                    setSurfaceForms(Array.isArray(data.surfaceForms) ? data.surfaceForms : []);
                    setLoading(false);
                }
            })
            .catch(err => {
                if (!cancelled) {
                    setError(err);
                    setLoading(false);
                }
            });

        return () => { cancelled = true; };
    }, [entityId, refetchKey]);

    return {wikidataAliases, surfaceForms, loading, error};
}
